import * as React from "react"
import ContactForm from "./form"

const Popup = () => {
	const closePopup = () => {
		document.body.classList.remove("popup-open")
	}
	return (
		<>
			<div className='popup--form br10'>
				<div className='p40 ml20 mr20 m-p20 m-m0'>
					<p className='h2 m0 max-600 ma mt40 m-m0'>Get in touch with our experts</p>
					<div className='mt20'>
						<ContactForm />
					</div>
				</div>
			</div>
			<div className='popup--bg' onClick={closePopup} role='presentation' />
		</>
	)
}

export default Popup
